import type { LucideIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface SettingsNavItemProps {
  label: string
  icon?: LucideIcon
  isActive?: boolean
  onClick?: () => void
  className?: string
}

const SettingsNavItemBase: React.FC<SettingsNavItemProps> = ({
  label,
  icon: Icon,
  isActive = false,
  onClick,
  className,
}): ReactNode => (
  <Button
    variant="ghost"
    onClick={onClick}
    className={cn(
      'settings-nav-item w-full justify-start gap-2 font-normal',
      isActive && 'bg-accent text-accent-foreground font-medium',
      className
    )}
  >
    {Icon && <Icon className="size-4 shrink-0" />}
    <span className="truncate">{label}</span>
  </Button>
)

export const SettingsNavItem = memo(SettingsNavItemBase)

SettingsNavItem.displayName = 'SettingsNavItem'
